import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Constants } from '../shared/constants';
import { ForgotPassword } from '../shared/models/forgotpassword.model';
import { BaseHttpService } from '../shared/services/basehttp.service';
import forge from 'node-forge';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from '../shared/services/notifications.service';
import { CognitoService, ICognitoUsermapping } from '../shared/services/cognito.service';
import { GroupModel, GroupUserModel } from '../admin/models/group.model';
import { UserType } from '../admin/models/usertype.model';



export interface IUsermapping {
  email: string;
  orgId: number;
  grpId: number;
  roleId: number;
  roleName: string;
}


@Component({
  selector: 'app-map-user-group',
  templateUrl: './map-user-group.component.html',
  styleUrl: './map-user-group.component.scss'
,  standalone: false
})

export class MapUserGroupComponent implements OnInit {


  public userMapUpdateForm: FormGroup
  public successMessage: string;
  public errorMessage: string;
  public showSuccess: boolean;
  public showError: boolean;
  public forgotpasswordscreeen: boolean = false;
  constant: Constants = new Constants();


  cognitoUserEmail: string;
  grpName: string;
  roleName: string;

  userOrgId: number;
  masterGroups: GroupModel[] = [];
  userGrpId: number;
  masterRoles: UserType[] = [];
  userRoleId: number;
  userOrgName: string = "";

  constructor(private _http: BaseHttpService, private router: Router, private spinnerService: NgxSpinnerService,
    private notificationService: NotificationService, private cognitoService: CognitoService
  ) { }

  ngOnInit(): void {
    //debugger;
    this.cognitoService.getUser().then((user: any) => {
      console.log("cognito user details:", user);
      this.cognitoUserEmail = user.attributes['email'];
      this.getUserExistingDetails();
    }).catch(() => {
      return false;
    });

    this.userMapUpdateForm = new FormGroup({
      email: new FormControl("", [Validators.nullValidator]),
      org: new FormControl("", [Validators.nullValidator]),
      grp: new FormControl("", [Validators.required]),
      role: new FormControl("", [Validators.required])
    })
  }
  getUserExistingDetails() {
    this.spinnerService.show();
    this._http.getById(this.constant.getUserGroupRoleByEmail, this.cognitoUserEmail).subscribe((result) => {
      if (result != null) {
        console.log("user details:", result);
        this.userOrgId = result.organizationId;
        this.userGrpId = result.groupId;
        this.getGroups();
        this.getRoles();
        this.userRoleId = result.userTypeId;
        this.userOrgName = result.organization.name;
        this.spinnerService.hide();
      }
      else {
        this.notificationService.showError("Unable to fetch user details.", "User Info Failure!");
      }
    });
  }
  getGroups() {
    this.spinnerService.show();
    this._http.getById(this.constant.getGroupsByOrganizationId, this.userOrgId.toString()).subscribe((result: GroupModel[]) => {
      console.log("group details:", result);
      this.masterGroups = result;
      this.spinnerService.hide();
    });
  }
  getRoles() {
    this.spinnerService.show();
    this._http.get(this.constant.getAllUserRoles).subscribe((result: UserType[]) => {
      console.log("role details:", result);
      this.masterRoles = result;
      this.spinnerService.hide();
    });
  }


  public validateControl = (controlName: string) => {
    return this.userMapUpdateForm.controls[controlName].invalid && this.userMapUpdateForm.controls[controlName].touched
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.userMapUpdateForm.controls[controlName].hasError(errorName)
  }

  public forgotPassword = (userMapUpdateFormValue) => {
    this.spinnerService.show();
    this.showError = this.showSuccess = false;
    let rsa = forge.pki.publicKeyFromPem(this.constant.publicKey);
    // userMapUpdateFormValue.email = window.btoa(rsa.encrypt(userMapUpdateFormValue.email));
    userMapUpdateFormValue.email = window.btoa(rsa.encrypt(userMapUpdateFormValue.email, 'RSA-OAEP', {
      md: forge.md.sha1.create()
    }));
    const forgotPass = { ...userMapUpdateFormValue };
    const forgotPassDto: ForgotPassword = {
      email: forgotPass.email,
      clientURI: window.location.origin + this.constant.resetURL,
      password: ""
    }

    this._http.post(this.constant.forgotPassword, forgotPassDto)
      .subscribe(_ => {
        this.showSuccess = true;
        this.spinnerService.hide();
        this.router.navigate(['/', 'home'])
        this.notificationService.showSuccess("Please check your email to reset your password.", "Link has been sent");
      },
        err => {
          this.showError = true;
          this.errorMessage = err.error;
          this.spinnerService.hide();
        }
      )
  }



  updateUsermapping(userMapUpdateFormValue){
//  public updateUsermapping = (userMapUpdateFormValue) => {
    this.spinnerService.show();
    let mapping = {} as ICognitoUsermapping;
    mapping.groupId =  userMapUpdateFormValue.userGrpId;
    mapping.roleId =  userMapUpdateFormValue.userRoleId;
    mapping.email = this.cognitoUserEmail;

    this._http.post(this.constant.updateCognitoUserMapping, mapping).subscribe(result => {
        this.showSuccess = true;
        this.spinnerService.hide();
        this.router.navigate(['/', 'home'])
        this.notificationService.showSuccess("Please check your email to reset your password.", "Link has been sent");
      },
        err => {
          this.showError = true;
          this.errorMessage = err.error;
          this.spinnerService.hide();
        }
      )

  }

  cancel() {
    this.router.navigate(['/', 'login'])
  }

}
